//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProductToSearch"
import StockAdjustTypeModel from "@/models/Warehouse/WhStockAdjustType"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"

//
import StockAdjustDetailHeaders from "./headers"

//
export default [
    {
        name: "wh_warehouse_from_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Origen",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            rules: [ required ],
        },
        trigger(ctx) {

            //
            const wh_product_to_repackage = ctx.getInput( "wh_product_to_repackage_id" ).getSelected()
            const wh_warehouse_from_id = ctx.value.wh_warehouse_from_id

            //
            //ProductModel.params({ logical_stocks: '1' }).find(wh_product_to_repackage.id).then(wh_product => {
                //ctx.value.wh_product_stock = wh_product.logical_stocks ?
                ctx.value.wh_product_stock = wh_product_to_repackage.logical_stocks ?
                    //wh_product.logical_stocks
                    wh_product_to_repackage.logical_stocks
                        .reduce((r, c) => [ ...r, ...c.wh_warehouses ], [])
                        .reduce((r, c) => c.wh_warehouse_id === wh_warehouse_from_id ? Number(c.logical_stock_real).toFixed(2) : r, 0)
                    :
                    0

                ctx.$forceUpdate()
            //})           
        },
    },
    {
        name: "wh_product_to_repackage_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            attachParams: {
                logical_stocks: '1',
            },
            append: [
                'repacking_children',
                //'stocks',
            ],
            itemText: "name",
            itemValue: "id",
            label: "Producto",
            loadingText: "Cargando productos...",
            model: ProductModel,
            noDataText: "Sin productos.",
            noModeler: true,
            noObject: true,
            paramFilter: {
                is_repacking_parent: true,
            },
            paramSearch: "search",
            rules: [ required ],
        },
        trigger ( ctx ) {

            //
            var wh_warehouse_to_id = ctx.value.wh_warehouse_to_id
            var wh_product_selected = ctx.getInput( "wh_product_to_repackage_id" ).getSelected()
            var wh_product_stock = (wh_product_selected.logical_stocks || [])
                .reduce((r, c) => [ ...r, ...c.wh_warehouses ], [])
                .reduce((r, c) => c.wh_warehouse_id === ctx.value.wh_warehouse_from_id ? Number(c.logical_stock_real).toFixed(2) : r, 0)

            //
            if ( Array.isArray( wh_product_selected.repacking_children ) ) {
                ctx.value.wh_selected_products = wh_product_selected.repacking_children.map( item => {

                    item['stock'] = 0
                    item['required'] = 0

                    ProductModel.params({ logical_stocks: '1' }).find(item.id).then(res => {
                        item['stock'] = res.logical_stocks ?
                            res
                            .logical_stocks
                            .reduce((r, c) => [ ...r, ...c.wh_warehouses ], [])
                            .reduce((r, c) => c.wh_warehouse_id === wh_warehouse_to_id ? Number(c.logical_stock_real).toFixed(2) : r, 0)
                            :
                            0
                    })

                    return {
                        ...item,
                        ...item.wh_item,
                        ...item.wh_item.wh_product,
                        quantity: 0,
                        required: 0,
                    }
                })
            } else {
                ctx.value[ "wh_selected_products" ] = []
            }

            wh_product_selected.g_branch_office_id = wh_product_selected.store_user_branch_office_id

            console.log({ wh_product_selected })

            //
            ctx.value.wh_item_to_repackage_id = wh_product_selected.wh_item_id
            ctx.value.wh_product_stock = wh_product_stock
        },
    },
    {
        name: "wh_product_stock",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Stock",
            readonly: true,
        },
    },
    {
        name: "wh_warehouse_to_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Destino",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            rules: [ required ],
        },
        trigger( ctx ) {

            //
            const selected = ctx.value.wh_selected_products
            const warehouse = ctx.value.wh_warehouse_to_id

            //
            selected.forEach(item => {
                ProductModel.params({ logical_stocks: '1' }).find(item.id).then(res => {
                    item['stock'] = res.logical_stocks ?
                        res
                        .logical_stocks
                        .reduce((r, c) => [ ...r, ...c.wh_warehouses ], [])
                        .reduce((r, c) => c.wh_warehouse_id === warehouse ? Number(c.logical_stock_real).toFixed(2) : r, 0)
                        :
                        0
                })
            })
        },
    },
    {
        name: "wh_selected_products",
        type: "table-field",
        flex: {
            "pt-0": true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers: StockAdjustDetailHeaders,
            noActions: true,
            noDataText: "Sin productos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: "Items",
            rules: [ required ],
            showNativePagination: true,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: "Lista de productos incluidos en el reenvasado",
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
        },
    },
    {
        name: "comment",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Comentario",
            rules: [ required ],
        },
    },
    /*{
        name: "is_opened",
        type: "switch",
        flex: {
            xs12: true,
        },
        props: {
            label: "El producto se encuentra abierto.",
            //rules: [ required ],
        },
    },*/
]